
export enum MessageLogStatusCd {
	ACKNOWLEGED = 'Acknowleged',
	PROCESSING_FAILED = 'ProcessingFailed',
	PROCESSING_SUCCESSFUL = 'ProcessingSuccessful',
	RESENT = 'Resent',
	SEND_FAILED = 'SendFailed',
	SEND_SUCCESSFUL = 'SendSuccessful'}

